import { createContext, useContext } from 'react';

type Props = {
  children: React.ReactNode;
  value: boolean;
};

const IsInHeaderContext = createContext<boolean>(false);

export function IsInHeaderProvider({ value, children }: Props) {
  return (
    <IsInHeaderContext.Provider value={value}>
      {children}
    </IsInHeaderContext.Provider>
  );
}

export function useIsInHeader() {
  return useContext(IsInHeaderContext);
}
